const environmentConfig = {
  rabbitMQ: {
    url: "wss://ws.xkool.ai",
    login: "xkool",
    passCode: "xkoolart123",
    host: "arp_urbantool",
  },
};

export default environmentConfig;
